Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _airbnbPropTypes = require('airbnb-prop-types');

var _withStyles = require('../themes/withStyles');

var _withBrand = require('../themes/withBrand');

var _withBrand2 = _interopRequireDefault(_withBrand);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var colorScheme = (0, _airbnbPropTypes.mutuallyExclusiveTrueProps)('light', 'dark');

var propTypes = (0, _airbnbPropTypes.forbidExtraProps)(Object.assign({}, _withStyles.withStylesPropTypes, {

  small: _propTypes2['default'].bool,
  large: _propTypes2['default'].bool,
  light: colorScheme,
  dark: colorScheme,
  inline: _propTypes2['default'].bool,
  brand: _withBrand.requiredBrandPropType
}));

var defaultProps = {
  small: false,
  large: false,
  dark: false,
  light: false
};

var fadeDelay = {
  '0%, 80%, 100%': {
    opacity: 0
  },
  '30%, 50%': {
    opacity: 1
  }
};

function Loader(_ref) {
  var css = _ref.css,
      small = _ref.small,
      large = _ref.large,
      light = _ref.light,
      dark = _ref.dark,
      styles = _ref.styles,
      inline = _ref.inline,
      brand = _ref.brand;

  var isSelectBrand = brand === _withBrand.BRAND_SELECT;
  var dotColor = isSelectBrand ? styles.dotDefault_select : styles.dotDefault;
  if (light) {
    dotColor = styles.dotLight;
  } else if (dark) {
    dotColor = styles.dotDark;
  }

  return _react2['default'].createElement(
    'div',
    css(styles.container, !inline && styles.container_absoluteCenter, inline && styles.container_inline),
    _react2['default'].createElement('div', css(styles.dot, large && styles.dot_large, small && styles.dot_small, dotColor, styles.dot1)),
    _react2['default'].createElement('div', css(styles.dot, large && styles.dot_large, small && styles.dot_small, dotColor, styles.dot2)),
    _react2['default'].createElement('div', css(styles.dot, large && styles.dot_large, small && styles.dot_small, dotColor))
  );
}

Loader.componentCategory = 'Core';
Loader.displayName = 'Loader';
Loader.propTypes = propTypes;
Loader.defaultProps = defaultProps;

exports['default'] = (0, _withBrand2['default'])((0, _withStyles.withStyles)(function (_ref2) {
  var color = _ref2.color;
  return {
    container: {
      marginTop: 0,
      marginBottom: 0,
      marginLeft: 'auto',
      marginRight: 'auto',
      textAlign: 'center'
    },

    container_absoluteCenter: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translateX(-50%) translateY(-50%)'
    },

    container_inline: {
      display: 'inline-block'
    },

    dot: {
      width: 6,
      height: 6,
      marginRight: 4,
      borderRadius: '100%',
      display: 'inline-block',
      animationName: fadeDelay,
      animationDuration: '0.8s',
      animationIterationCount: 'infinite',
      animationTimingFunction: 'linear',
      animationFillMode: 'both',
      verticalAlign: 'middle'
    },

    dotDefault: {
      backgroundColor: color.loaderDots['default']
    },

    dotLight: {
      backgroundColor: color.loaderDots.light
    },

    dotDark: {
      backgroundColor: color.loaderDots.dark
    },

    dotDefault_select: {
      backgroundColor: color.core.hackberry
    },

    dot1: {
      animationDelay: '-0.3s'
    },

    dot2: {
      animationDelay: '-0.15s'
    },

    dot_large: {
      width: 12,
      height: 12,
      marginRight: 8
    },

    dot_small: {
      width: 4,
      height: 4,
      marginRight: 2
    }
  };
})(Loader));


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-dls-web/build/exp/Loader.js
// module id = 247
// module chunks = 168707334958949